import moment from 'moment'

/* GET START AND END DATE  */
export const getToday = () => {

    const startDate = moment().format('YYYY-MM-DD 00:00:00')
    const endDate = moment().format('YYYY-MM-DD 23:59:59')

    return { startDate, endDate }
}

/* GET DASHBOARD FILTER DATE */
export const getFilterDates = type => {

    /* Week */
    if (type === "week") {
        const start = moment().startOf('week').format('YYYY-MM-DD 00:00:00')
        const end = moment().endOf('week').format('YYYY-MM-DD 23:59:59')
        return { start, end }
    }

    /* Month */
    if (type === "month") {
        const start = moment().startOf('month').format('YYYY-MM-DD 00:00:00')
        const end = moment().endOf('month').format('YYYY-MM-DD 23:59:59')
        return { start, end }
    }

    /* Year */
    if (type === "year") {
        const start = moment().startOf('year').format('YYYY-MM-DD 00:00:00')
        const end = moment().endOf('year').format('YYYY-MM-DD 23:59:59')
        return { start, end }
    }

    /* Default */
    const start = moment().format('YYYY-MM-DD 00:00:00')
    const end = moment().format('YYYY-MM-DD 23:59:59')

    return { start, end }
}

/* TRANSLIT */
export const translit = word => {

    let text = ''

    const converter = {
        'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd',
        'е': 'e', 'ё': 'e', 'ж': 'zh', 'з': 'z', 'и': 'i',
        'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
        'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't',
        'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'ch',
        'ш': 'sh', 'щ': 'sch', 'ь': '', 'ы': 'y', 'ъ': '',
        'э': 'e', 'ю': 'yu', 'я': 'ya',

        'А': 'a', 'Б': 'b', 'В': 'b', 'Г': 'g', 'Д': 'd',
        'Е': 'e', 'Ё': 'e', 'Ж': 'zh', 'З': 'z', 'И': 'i',
        'Й': 'y', 'К': 'k', 'Л': 'l', 'М': 'm', 'Н': 'n',
        'О': 'o', 'П': 'p', 'Р': 'r', 'С': 's', 'Т': 't',
        'У': 'u', 'Ф': 'f', 'Х': 'H', 'Ц': 'C', 'Ч': 'ch',
        'Ш': 'sh', 'Щ': 'sch', 'Ь': '', 'Ы': 'y', 'Ъ': '',
        'Э': 'e', 'Ю': 'yu', 'Я': 'ya'
    }


    for (let i = 0; i < word.length; ++i) {
        if (word[i] === " ") {
            text += "-"
        }
        else if (converter[word[i]] === undefined || converter[word[i]] === null) {
            text += word[i]
        }
        else {
            text += converter[word[i]]
        }
    }

    return text

}

/* Check Element */
export const check = (value, defaultValue = "") => {

    if (value !== undefined && value !== null) {
        return value
    }

    return defaultValue
}

/* PRICE CONVERTOR */
export const convertor = (price, symbol = "", isAfter = 0, space = "\u0020", defaultValue = "") => {

    /* Check the price for the void */
    if (price === null || price === undefined)
        return defaultValue

    const number = Number.isInteger(parseInt(price)) ? parseInt(price) : Number.parseFloat(price).toFixed(2)

    let before = ""
    let after = ""

    if (parseInt(isAfter) === 1) {
        after = "\u0020" + symbol
    }

    if (parseInt(isAfter) === 0) {
        before = symbol + "\u0020"
    }

    return before + number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, space) + after
}
